import React from 'react'
import PropTypes from 'prop-types'

import { optionListItemStyle, hiddenAnchorStyle } from '../styles'

import RadioInput from '../RadioInput/RadioInput'

const OptionListItemRadio = ({ id, isSelected, onClick, label, children, enabled }) => (
  <div className='row' key={id} style={optionListItemStyle}>
    <div className='col-1' >
      <RadioInput enabled={enabled} selected={isSelected} onClick={() => enabled && onClick(id)} />
    </div>
    <div className='col-11' onClick={(e) => { e.preventDefault(); enabled && onClick(id);}}>
      <a href='' style={hiddenAnchorStyle}>{label}</a>
    </div>
    {children}
  </div>);

OptionListItemRadio.propTypes = {
  enabled: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

OptionListItemRadio.defaultProps = {
  enabled: true
}

export default OptionListItemRadio


// WEBPACK FOOTER //
// ./src/Components/checkout/components/OptionList/OptionListItemRadio.jsx